import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { removeItem, resetWishlist } from "../../redux/wishlistReducer";
import { addToCart } from "../../redux/cartReducer";
import { useDispatch } from "react-redux";

const Wishlist = () => {
  const navigate = useNavigate();
  const products = useSelector((state) => state.wishlist.products);
  const dispatch = useDispatch();

  return (
    <div className="container py-5">
      <div className="row">
        <h1>Products in your wishlist</h1>
        {products?.map((item) => (
          <div className="col-md-4 mt-4" key={item.id}>
            <div className="card mb-4 product-wap rounded-0">
              <div className="card rounded-0">
                <span className="newMark bg-dark"><i className="fas fa-trash" 
                  onClick={() => dispatch(removeItem(item.id))}></i></span>
                <img className="card-img" src={process.env.REACT_APP_UPLOAD_URL + item.img} alt="" />
                <div className="card-body">
                    <Link to={`/product/${item.title_slug}`} className="h2 text-decoration-none text-dark">{item.title}</Link>
                    {/*<p className="card-text card-desc">
                        {item.description.length > 50 ? 
                        <ReactMarkdown>{item.description.substring(0, 49) + "..."}</ReactMarkdown> : 
                        <ReactMarkdown>{item.description}</ReactMarkdown> }
                    </p>*/}
                    <p className="text-center mb-0 mt-3">{item.quantity} x ₹ {item.price}</p>
                </div>
                <div className="col d-grid">
                  <button
                    className="btn btn-success btn-lg" onClick={() => {
                      dispatch(
                        addToCart({
                          id: item.id,
                          title: item.title,
                          title_slug: item.title_slug,
                          desc: item.desc,
                          price: item.price,
                          img: item.img,
                          quantity: item.quantity,
                          file: item.file,
                          fileId: item.fileId,
                          message: item.message,
                        })
                      );
                      dispatch(removeItem(item.id)) && navigate("/cart", { replace: true }
                      );
                    } }
                  ><i className="fas fa-cart-plus" /> MOVE TO CART</button>
                </div>
              </div>
            </div>
          </div>
        ))}
        {(products.length > 0) ? 
        <div className="row text-center">
        <span className="reset" onClick={() => dispatch(resetWishlist())}>
          Reset Wishlist
        </span>
      </div> : <div className="text-center h3 p-5"> Your Wishlist is Empty! To keep track of them</div>}
      </div>
    </div>
  );
};

export default Wishlist;
